module.exports = __webpack_public_path__ + "img/youtube-social.4ffdc510.svg";